export function isObject(value: any): value is Record<string | symbol | number, any> {
  return Object.prototype.toString.call(value) === '[object Object]';
}
